'use strict'

const wixCodeMessageTypes = require('../wixCodeMessageTypes')

const isMessageSupported = messageData => {
  const SUPPORTED_INTENTS = [
    wixCodeMessageTypes.WIX_CODE_INTENT,
    wixCodeMessageTypes.TPA_NATIVE_EVENT,
    wixCodeMessageTypes.UPDATE_QUEUE_INTENT,
    wixCodeMessageTypes.WIX_CODE_ANIMATE
  ]
  return SUPPORTED_INTENTS.includes(messageData ? messageData.intent : null)
}

const isWorkerLifeCycleMessage = messageData => {
  const WORKER_LIFE_CYCLE_MESSAGES = ['wix_code_worker_bootstrap', 'wix_code_worker_load_user_code', 'wix_code_worker_init', 'wix_code_worker_load', 'wix_code_worker_start', 'wix_code_worker_stop', 'trigger_onRender', 'update_wix_code_model_data_after_login', 'wix_code_worker_bi_data_update']
  return WORKER_LIFE_CYCLE_MESSAGES.includes(messageData ? messageData.type : null)
}

const isWixCodeResponseMessage = messageData => messageData && messageData.intent === wixCodeMessageTypes.WIX_CODE_RESPONSE

const isWorkerPubSubMessage = messageData => messageData && messageData.type === wixCodeMessageTypes.INVOKE_WORKER_SUBSCRIBERS

const shouldSendMessageToWorker = messageData => isMessageSupported(messageData) || isWixCodeResponseMessage(messageData) || isWorkerLifeCycleMessage(messageData) || isWorkerPubSubMessage(messageData)

module.exports = {
    shouldSendMessageToWorker
}
